<script lang="ts">
import {Link} from "svelte-navigator";
import {isLoggedIn} from "../../store/loginV2";

export let to
</script>

{#if $isLoggedIn}
    <Link to="{to}">
        <slot />
    </Link>
{/if}
